import {
  keepPreviousData,
  QueryCache,
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import { FetcherProviderPropertiesType } from "@website/fetcher/provider/provider.types";
import { deepCompare } from "@website/fetcher/provider/utils";
import { FC, memo } from "react";

const queryCache = new QueryCache();

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      gcTime: 15 * 60 * 1000, // Garbage collect after 15 minutes
      placeholderData: keepPreviousData,
      staleTime: 15 * 60 * 1000 //stale for 15 minutes
    }
  }
});

const Component: FC<FetcherProviderPropertiesType> = ({ children }) => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export const FetcherProvider = memo(Component, deepCompare);
